import React from 'react'
import { Grid, Link, Typography } from '@mui/material'

const sx = {
    header: {
        color: 'color.darkBlue',
    },
    content: {
        color: 'color.darkBlue70',
        marginTop: "10px",
        marginBottom: "10px"
    },
    state: {
        color: 'color.darkBlue70',
    },
    website: {
        color: "color.darkBlue70",
        marginBottom: "10px"
    }, linkText: {
        color: "color.blue20",
        textDecoration: "none"
    }
}

const SecretaryState = ({ tab, stateContactInfo }) => {
    const state = stateContactInfo?.stateCode || 'No data'
    return (
        <Grid item xs={10.5}>
            <Typography variant="h6" sx={sx.header}>
                Confirm & update your {tab} information.
            </Typography>
            <Typography variant="body2" sx={sx.content}>
                This page shows the publicly available {tab} information about your business. Select the Correct or
                Incorrect button to update your business information displayed in Markaaz and track what public
                information matches your current business data.
            </Typography>
            <Typography variant="body2" sx={sx.content}>
                Markaaz continually checks the publicly available data sources. Once your public information matches
                the current information displayed in Markaaz, it will automaticallty become matched.
            </Typography>
            <Typography variant="body2" sx={sx.content}>
                To update your business information outside of Markaaz, please reach out to the following contact
                information for your Secretary of State in {state} and they will provide you all the steps needed
                to update it publicly.
            </Typography>
            {stateContactInfo?.email && <Typography variant="body2" sx={sx.state}>
                Email: <Link href={`mailto:${stateContactInfo?.email}`} target="_blank" rel="noreferrer" sx={sx.linkText}>{stateContactInfo?.email}</Link>
            </Typography>}
            {stateContactInfo?.phoneNumber && <Typography variant="body2" sx={sx.state}>
                Phone Number: <Link href={`tel:${stateContactInfo?.phoneNumber}`} target="_blank" rel="noreferrer" sx={sx.linkText}>{stateContactInfo?.phoneNumber}</Link>
            </Typography>}
            {stateContactInfo?.physicalAddress && <Typography variant="body2" sx={sx.state}>
                Address: {stateContactInfo?.physicalAddress}
            </Typography>}
            {stateContactInfo?.url && <Typography variant="body2" sx={sx.website} >
                Website: <Link href={stateContactInfo?.url} target="_blank" rel="noreferrer" sx={sx.linkText}>{stateContactInfo?.url}</Link>
            </Typography>}
        </Grid >
    )
}

export default SecretaryState